/* mobile-pdp-20261021 (B): when a product has more than one ring size, no size is preselected
   and add to cart waits until the shopper picks one. Single-size products are not affected
   (Liquid only adds data-stav-size-required when the size option has more than one value). */
(() => {
  const picker = document.querySelector('.stav-pdp-redesign .product-detail__variant-picker[data-stav-size-required]');
  if (!picker) return;
  const radios = picker.querySelector('variant-radios-detail, variant-group-detail');
  if (!radios) return;
  // This file loads before theme.js; wait until the theme has upgraded the variant picker.
  customElements.whenDefined(radios.localName).then(() => stavSizeRequiredInit(picker, radios));
})();

function stavSizeRequiredInit(picker, radios) {
  if (picker.dataset.stavSizeInit) return;
  picker.dataset.stavSizeInit = 'true';
  const position = parseInt(picker.dataset.stavSizeRequired, 10);
  const section = picker.closest('.stav-pdp-redesign');
  if (!section || !position) return;
  const fieldsets = [...radios.querySelectorAll('fieldset')];
  const sizeFieldset = fieldsets[position - 1];
  if (!sizeFieldset) return;
  const sizeInputs = [...sizeFieldset.querySelectorAll('input[type="radio"]')];
  if (sizeInputs.length < 2) return;
  const prompt = picker.querySelector('.stav-size-prompt');
  const sectionId = section.dataset.section;
  const form = document.getElementById(`product-form-${sectionId}`);
  const addButton = form && form.querySelector('[name="add"]');
  const sticky = section.querySelector('sticky-add-cart');
  // Sticky bar variant select: shows a "choose a size" placeholder until a size is picked (QA fail 3).
  const stickyRadios = sticky && sticky.querySelector('variant-radios-sticky, variant-group-sticky');
  const stickySelect = stickyRadios && stickyRadios.querySelector('select');
  const placeholderText = picker.dataset.stavSizePlaceholder
    || ((document.documentElement.lang || '').toLowerCase().startsWith('en') ? 'Choose a size' : 'בחרו מידה');
  let stickyPlaceholder = null;
  const storageKey = `stavSizeChosen:${picker.dataset.productId}`;
  let chosen = false;
  const buttonLabel = addButton && addButton.querySelector(':scope > span');
  const buttonLabelText = buttonLabel ? buttonLabel.textContent : '';

  const variants = (() => {
    try { return radios.getVariantData(); } catch (error) { return []; }
  })();
  const sizeChecked = () => sizeInputs.some((input) => input.checked);

  // Keep a size the shopper already chose on this product in this tab (e.g. after a reload).
  try {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant && sessionStorage.getItem(storageKey) === urlVariant && sizeChecked()) return;
  } catch (error) { /* storage blocked: just require the choice */ }

  const setWaiting = () => {
    if (!addButton) return;
    addButton.setAttribute('disabled', 'disabled');
    addButton.dataset.stavSizeWait = 'true';
    if (prompt) {
      if (!prompt.id) prompt.id = `StavSizePrompt-${sectionId}`;
      addButton.setAttribute('aria-describedby', prompt.id);
    }
  };

  const showStickyPlaceholder = () => {
    if (!stickySelect) return;
    if (!stickyPlaceholder || !stickyPlaceholder.isConnected) {
      stickyPlaceholder = document.createElement('option');
      stickyPlaceholder.value = '';
      stickyPlaceholder.disabled = true;
      stickyPlaceholder.dataset.stavSizePlaceholder = 'true';
      stickyPlaceholder.textContent = placeholderText;
      stickySelect.insertBefore(stickyPlaceholder, stickySelect.firstChild);
    }
    [...stickySelect.options].forEach((option) => {
      option.selected = false;
      option.removeAttribute('selected');
    });
    stickyPlaceholder.selected = true;
    stickySelect.selectedIndex = 0;
  };

  const removeStickyPlaceholder = () => {
    if (stickyPlaceholder && stickyPlaceholder.isConnected) stickyPlaceholder.remove();
    stickyPlaceholder = null;
  };

  // Show the chosen variant in the sticky bar (the theme does this too; repeat it in case it skipped).
  const syncStickyToVariant = (variant) => {
    if (!stickySelect || !variant) return;
    const option = [...stickySelect.options].find((item) => item.dataset.variantId === String(variant.id));
    if (option) option.selected = true;
  };

  const clearSize = () => {
    sizeInputs.forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });
    sizeFieldset.querySelectorAll('.option_value').forEach((label) => { label.textContent = ''; });
    if (prompt) prompt.hidden = false;
    showStickyPlaceholder();
    setWaiting();
  };

  const markChosen = () => {
    if (!sizeChecked()) return;
    chosen = true;
    removeStickyPlaceholder();
    picker.classList.remove('stav-size-needed');
    if (prompt) prompt.hidden = true;
    if (addButton) {
      delete addButton.dataset.stavSizeWait;
      addButton.removeAttribute('aria-describedby');
      if (!radios.currentVariant) {
        const values = fieldsets.map((fieldset) => {
          const checked = [...fieldset.querySelectorAll('input[type="radio"]')].find((input) => input.checked);
          return checked ? checked.value : null;
        });
        radios.currentVariant = variants.find((item) => item.options.every((value, index) => values[index] === value));
      }
      const variant = radios.currentVariant;
      if (variant && variant.available) addButton.removeAttribute('disabled');
      syncStickyToVariant(variant);
      try { if (variant) sessionStorage.setItem(storageKey, String(variant.id)); } catch (error) { /* ignore */ }
    }
  };

  // Another option (e.g. gold colour) changed while no size is chosen yet: the theme treats that as
  // "unavailable". Show the matching price and photo instead, and keep add to cart waiting for a size.
  const showWithoutSize = () => {
    const values = fieldsets.map((fieldset) => {
      const checked = [...fieldset.querySelectorAll('input[type="radio"]')].find((input) => input.checked);
      return checked ? checked.value : null;
    });
    const match = variants.find((variant) =>
      variant.options.every((value, index) => index === position - 1 || values[index] === null || values[index] === value)
    );
    if (match) {
      radios.productTarget = radios.productTarget || section;
      radios.currentVariant = match;
      try {
        radios.updatePrice(radios.productTarget);
        radios.setAvailable();
        radios.updateMedia();
        radios.updatePickupAvailability();
      } catch (error) { /* keep going */ }
      radios.currentVariant = undefined;
    }
    if (buttonLabel && buttonLabelText) buttonLabel.textContent = buttonLabelText;
    setWaiting();
  };

  const askForSize = () => {
    picker.classList.add('stav-size-needed');
    if (prompt) prompt.hidden = false;
    sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // The theme's option-availability pass expects every option to be checked; skip it until a size is chosen.
  if (typeof radios.updateVariantStatuses === 'function') {
    const updateVariantStatuses = radios.updateVariantStatuses;
    radios.updateVariantStatuses = function stavUpdateVariantStatuses(...args) {
      if (!sizeChecked()) return undefined;
      return updateVariantStatuses.apply(this, args);
    };
  }

  radios.addEventListener('change', (event) => {
    if (chosen) return;
    if (sizeFieldset.contains(event.target)) {
      markChosen();
    } else {
      showWithoutSize();
    }
  });

  // Guard both add-to-cart forms (main and the existing sticky bar) until a size is chosen.
  const guard = (event) => {
    if (chosen) return;
    const target = event.target;
    if (event.type === 'click' && !(target.closest && target.closest('[name="add"], [type="submit"]'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    askForSize();
  };
  if (form) form.addEventListener('submit', guard, true);
  if (sticky) {
    sticky.addEventListener('click', guard, true);
    sticky.addEventListener('submit', guard, true);
    // Choosing a variant (size included) in the sticky bar counts as choosing a size: select the same
    // variant in the main picker, then clear the prompt and enable the main button.
    // The theme fires a change on the bar's hidden variant input before the select's own change
    // finishes, so read the variant from the select whichever event arrives first.
    sticky.addEventListener('change', () => setTimeout(() => {
      if (chosen) return;
      const option = stickySelect && stickySelect.options[stickySelect.selectedIndex];
      const variantId = option && !option.dataset.stavSizePlaceholder ? option.dataset.variantId : null;
      const variant = variantId && variants.find((item) => String(item.id) === variantId);
      if (!variant) {
        if (sizeChecked()) markChosen();
        return;
      }
      fieldsets.forEach((fieldset, index) => {
        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          const match = input.value === variant.options[index];
          input.checked = match;
          if (match) input.setAttribute('checked', ''); else input.removeAttribute('checked');
        });
      });
      radios.currentVariant = variant;
      markChosen();
    }, 0));
  }

  clearSize();
  // The theme may re-apply the default selection while it finishes initialising.
  requestAnimationFrame(() => setTimeout(() => { if (!chosen) clearSize(); }, 0));
}
